<ul class="nav nav-tabs">
  @for (tab of tabNames | keyvalue; track tab) {
    <li class="nav-item" (click)="changeTab(tab.value)">
      <a
        class="nav-link"
        data-toggle="tab"
        [ngClass]="selectedTab === tab.value ? 'active' : ''"
        >{{ tab.value }}</a
      >
    </li>
  }
</ul>

@if (selectedTab == tabNames.tab3) {
  <gtapp-monitoring-company></gtapp-monitoring-company>
} @else {
  @if ([tabNames.tab1].includes(selectedTab)) {
    <div class="me-lg-2 my-2 text-end d-flex gap-1 justify-content-end">
      @if (totalJobCount >= 1) {
        @if (filterJobType !== "response") {
          <button
            class="btn btn-sm btn-outline-primary"
            (click)="alternateJobTypes('response')"
          >
            Responses
          </button>
        }
        @if (filterJobType !== "adHoc") {
          <button
            class="btn btn-sm btn-outline-primary"
            (click)="alternateJobTypes('adHoc')"
          >
            Casual
          </button>
        }
        @if (["adHoc", "response"].includes(filterJobType)) {
          <button
            class="btn btn-outline-success btn-sm"
            (click)="alternateJobTypes()"
          >
            Show Both
          </button>
        }
      }
      @if (
        totalJobCount >= 1 && (defaultJob ? totalJobCount != totalRows : true)
      ) {
        <button
          class="btn btn-sm"
          (click)="showAllJobsDesktop()"
          id="showResetJob"
          [ngClass]="defaultJob ? 'btn-outline-danger' : 'btn-danger'"
        >
          {{ defaultJob ? "All Status" : "Active Only" }}
        </button>
      }
      @if (totalJobCount > 5 && !largeView) {
        <button
          id="sortJobs"
          class="btn btn-secondary btn-sm"
          (click)="isSortPopupVisible = !isSortPopupVisible"
        >
          <i class="fa-solid fa-arrow-up-wide-short fa-lg"></i>
        </button>
      }
    </div>
    <div
      class="dropdown-menu shadow sort-popover-position"
      [ngClass]="{
        'd-none': !isSortPopupVisible,
        'd-block': isSortPopupVisible,
      }"
      id="popoverContent"
    >
      @for (item of sortItemList; track item) {
        <div class="row align-items-center p-2" (click)="sortField(item)">
          <button class="btn btn-outline-secondary w-100 text-start">
            {{ item.header }}
            <span class="float-end">
              @if (item?.sortOrder) {
                <span>
                  <i class="fa fa-arrow-down"></i>
                </span>
              }
              @if (!item?.sortOrder) {
                <span>
                  <i class="fa fa-arrow-up"></i>
                </span>
              }
            </span>
          </button>
        </div>
      }
    </div>
    <div class="d-flex gap-2 flex-wrap p-2">
      @if (addResponseJob) {
        <div>
          <button
            id="addResponse"
            class="btn btn-primary btn-lg"
            (click)="openAddJobForm()"
          >
            + Alarm Response
          </button>
        </div>
      }
      @if (addCasualPatrolJob) {
        <div>
          <button
            id="addCasualPatrol"
            class="btn btn-outline-primary btn-lg"
            (click)="openAdHocJobForm()"
          >
            + Casual Patrol
          </button>
        </div>
      }
      <!-- @if (totalJobCount > 5) {
        <div class="flex-grow-1" id="filterJob">
          <gtapp-auto-complete
            [data]="dropDownJobs"
            placeHolder="Search Jobs"
            searchKeyword="name"
            [initialValue]="globalFilter"
            [itemTemplate]="cpLookupTemplate"
            (inputChanged)="onFilterApply($event)"
            (selected)="openIndividualJob($event)"
            (submitted)="globalFilter = $event; onFilterApply($event)"
          >
          </gtapp-auto-complete>
          <ng-template #cpLookupTemplate let-item>
            <div>{{ item.job_key }} ({{ item.status }})</div>
            <div>{{ item?.site_name }} [{{ item?.company }}]</div>
          </ng-template>
        </div>
      } -->
    </div>
  }
  @if ([tabNames.tab2].includes(selectedTab)) {
    <div
      class="me-lg-2 my-2 text-end d-flex gap-2 justify-content-end align-items-center"
    >
      @if (totalJobCount >= 1) {
        <span> Showing </span>

        <select
          class="form-select w-auto"
          role="button"
          [ngModel]="selectedJobType?.id || ''"
          (change)="onSelectReviewJobType($event)"
        >
          @for (jType of jobTypesDataList; track $index) {
            <option [value]="jType.id">
              {{ jType?.name }}
            </option>
          }
        </select>
        <span> jobs only </span>
      }
    </div>
  }
  @if (totalJobCount > 0) {
    <div id="listJob">
      @if (largeView) {
        <gtapp-gt-table
          [desktopTableBackendData]="listJobData"
          [desktopTableDetails]="jobDetailsTableView"
          [tableStyle]="tableStyle"
          [otherParams]="otherParams"
          (paginationChange)="onChangePagination($event)"
          (sortColumn)="sortColumn($event)"
          (searchColumn)="searchColumn($event)"
          (rowClick)="openIndividualJob($event)"
        >
        </gtapp-gt-table>
      } @else {
        <gtapp-infinite-list
          [mobileCardBackendData]="infiniteJobList"
          [mobileCardDetails]="jobCardsDetails"
          [otherParams]="otherParams"
          [totalRows]="totalRows"
          (loadMoreData)="loadMoreJobs()"
          (rowClick)="openIndividualJob($event)"
          (searchColumn)="searchColumn($event)"
          (sortColumn)="sortColumn($event)"
        ></gtapp-infinite-list>
      }
    </div>
  }
}
